import { render } from "./ctechnic.vue?vue&type=template&id=134bee91&scoped=true"
import script from "./ctechnic.vue?vue&type=script&lang=js"
export * from "./ctechnic.vue?vue&type=script&lang=js"

import "./ctechnic.vue?vue&type=style&index=0&id=134bee91&scoped=true&lang=less"

import exportComponent from "D:\\Git仓库\\象新力官网\\html_xxldx_xxlx_xxlg\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-134bee91"]])

export default __exports__